import arhiv from '@/pages/MojArhiv'
import MyCompanyDelovniCasEdit from '@/pages/MyCompanyDelovniCasEdit'

export default [
  {
    path: '/arhiv',
    name: 'ArhivDelovnegaCasa',
    component: arhiv
  },
  {
    path: '/arhiv/vrni',
    name: 'vrniarhiv',
    component: arhiv
  },
  {
    path: '/uredi-dc',
    name: 'uredidc',
    component: MyCompanyDelovniCasEdit
  }
]
